// removed by extract-text-webpack-plugin
module.exports = {"info":"ca_cb _33-KZHL3bIaIUhCVTkSWy- _1L6YSXzlhVcylGdqFzi4Fw"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Footer/components/FooterInfo/styles.module.css
// module id = 1053
// module chunks = 27